// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CreateAssociationBinding, CreateAssociationBindingSchema } from 'api/gen/CreateAssociationBinding';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateAssociationBindingManagerBaseObject, ValidateAssociationBindingManagerBaseObjectSchema } from 'api/gen/ValidateAssociationBindingManagerBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateCreateAssociationBindingManager'),
  binding: t.union([CreateAssociationBindingSchema, t.null]),
});

export const ValidateCreateAssociationBindingManagerSchema = excess(t.intersection([ValidateAssociationBindingManagerBaseObjectSchema.type, requiredPart]));

export interface ValidateCreateAssociationBindingManager extends t.TypeOf<typeof ValidateCreateAssociationBindingManagerSchema> {}
